<router-outlet class="header" name="header"/>
<mat-sidenav-container fxFill>
  <mat-sidenav [opened]="!mobileQuery.matches" [mode]="mobileQuery.matches ? 'over' : 'side'" fixedTopGap="50" fxFlex="240px" #sidenav>
    <router-outlet name="sidenav"/>
  <!--app-sidenav (click)="mobileQuery.matches ? sidenav.close() : ''"></app-sidenav-->
</mat-sidenav>
<mat-sidenav-content fxFlex>
  <div id="main-container" class="main-container" fxFill>
    @if (!isHomeActive()) {
      <div class="page-info-container" style="display: none">
        <fa-icon icon="info-circle" size="lg" class="text-primary mr-1"></fa-icon>
        <span jhiTranslate="global.pageInfo">What does this page do?</span>
      </div>
    }
    <div class="main-content">
      <router-outlet/>
    </div>
  </div>
</mat-sidenav-content>
</mat-sidenav-container>
@if (!isMobilityBusinessArea() && (isAuthenticated() && (!isProduction || isAdmin()))) {
  <app-footer></app-footer>
}
<app-reload-footer></app-reload-footer>
